import { SESSION_EXPIRED } from "@/constants/settings";

import { keycloakAuthState } from "@/helpers/keycloakAuthState";

import { ApiError } from "@/types";

export const handleApiResponse = async (response: Response) => {
  if (response.status === 401) {
    if (keycloakAuthState.isKeycloakMode) {
      // In Keycloak mode: reload page so Istio redirects to Keycloak login
      window.location.reload();
      return;
    }
    throw SESSION_EXPIRED;
  }

  const responseJson = await response.json();

  if (responseJson.error) {
    throw responseJson as ApiError;
  }

  return responseJson;
};
